module.exports = __webpack_public_path__ + "static/media/eduTechImg2.4a651867.jpg";